import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { UsuariosPersonalService } from '../../../services/usuarios-personal.service';
import { ViajesService } from './../../../services/viajes.service';
import { CatalogosService} from '../../../services/catalogos.service';
import { UnidadesService} from '../../../services/unidades.service';

//Variable de google chart
declare var google:any;

@Component({
    selector:'linea-tiempo',
    templateUrl: './linea-tiempo-viajes.component.html',
    styleUrls: ['./linea-de-tiempo.styl']
})

export class LineaTiempoComponent {

	// usuario Actual
    currentUser:any;
    //Declaracion de variables
    public fechaSeleccionada:any;
    public tiposDeUnidad:Observable<any>;
    public tipoDeUnidad:any= 'todas';
    public sinResultados=true;
    public hoyInicio:any;
    public hoyFin:any;
    public diasSemana=['Domingo','Lunes','Martes','Miercoles','Jueves','Viernes','Sabado'];
    public diaActual:any;
    public diaAnterior:any;
    public diaDespues:any;

    listaDeOperadores=[]; //Lista FINAL de operadores DISPONIBLES
    listaDeUnidades:Observable<any>;

    constructor(
        //Importar Servicios
        private catalogoService:CatalogosService,
        private viajesService:ViajesService,
        private unidadesService:UnidadesService,
		private personalService:UsuariosPersonalService){}

        ngOnInit(){
            //Configura una fecha inicial, en el formato de un input date
            let fechaActual=new Date(Date.now())
            let mesActual:any= (fechaActual.getMonth()+1)
            if(mesActual <10) //Si el mes es menor a 10 agrega un 0
                mesActual= '0'+mesActual
            let diaActual:any= fechaActual.getUTCDate()
            if(diaActual <10) //Si el dia es menor a 10 agrega un 0
                diaActual= '0'+diaActual
            this.fechaSeleccionada= fechaActual.getFullYear()+'-'+ mesActual+'-'+diaActual;

            this.tiposDeUnidad= this.catalogoService.obtenerTiposDeUnidad().valueChanges().map(unidadesBD=>{
                let arregloNuevo=[]
                unidadesBD.forEach(tipo => {
                    let $key=tipo
                    if(tipo == 'Auto')
                        tipo=tipo+' - Auto'
                    if(tipo == 'Lujo')
                        tipo=tipo+' - Sprinter'
                    if(tipo == 'Tipo 1')
                        tipo=tipo+' - Toyota'
                    if(tipo == 'Tipo 2')
                        tipo=tipo+' - Sprinter'
                    arregloNuevo.push({data:tipo,key:$key})
                });
                return arregloNuevo
            });
            this.viajesPorFecha(this.fechaSeleccionada,'todas','','');

            let listaDeOperarios = this.personalService.obtenerOperadores().snapshotChanges().map(operadoresDB=>{
                let arreglo=[];
                operadoresDB.forEach(operador => {
                    let $key = operador.payload.key;
                    let data = operador.payload.val();
                    if(data.informacionLaboral.estatusPersonal != 'Baja')
                        arreglo.push({$key,...data})
                })
                return arreglo;
            });
            this.listaDeUnidades =  this.unidadesService.obtenerUnidades().snapshotChanges().map(uniadesDB=>{
                let arreglo=[]
                uniadesDB.forEach(unidad => {
                    let $key = unidad.payload.doc.id;
                    let data = unidad.payload.doc.data();
                    //Verifica si se esta filtrando por tipo o no

                    arreglo.push({$key,...data})

                });
                return arreglo.sort((a: any, b: any) => {
                    if(a.clave < b.clave) return -1;
                    if(a.clave > b.clave) return 1;
                });
            })

            Observable.zip(
                listaDeOperarios
            ).subscribe(todo=>{
                let arregloCompleto:Array<any>=todo[0] //Arreglo total
                this.listaDeOperadores = arregloCompleto;
            })

        }
        viajesPorFecha(fecha, tipo, unidad, operador){
            let fechaArreglo=fecha.split('-');
            let fechaTime= new Date(Number(fechaArreglo[0]),Number(fechaArreglo[1]-1),Number(fechaArreglo[2])).getTime();
            let horasExtra = 1000 * 60 * 60 * 8;
            this.diaActual=this.diasSemana[new Date(fechaTime).getDay()]
            this.diaAnterior=this.diasSemana[ new Date(new Date(fechaTime).setHours(0,0,0)- horasExtra).getUTCDay()]
            this.diaDespues=this.diasSemana[new Date(new Date(fechaTime).setHours(23,59,59,999)+ horasExtra).getDay()]
            this.hoyInicio = new Date(new Date(fechaTime).setHours(0,0,0)- horasExtra).getTime()
            this.hoyFin = new Date(new Date(fechaTime).setHours(23,59,59,999)+ horasExtra).getTime()+10000
            //Se realiza una consulta para poder  traer todos los servicios que esten
            this.mapearObservable(this.viajesService.obtenerViajesDentroDe40Horas(this.hoyInicio, this.hoyFin).snapshotChanges().map(viajes=>{
                let arr=[]
                viajes.forEach(viaje=>{
                    let $key= viaje.payload.doc.id
                    let data=viaje.payload.doc.data()
                    if(data.rotuloUnidad == undefined)
                    console.log($key)
                    arr.push({$key,...data})
                })
                return arr
            }).take(1),tipo, unidad,operador)

        }
        mapearObservable(res:Observable<any>, tipoDeUnidad, unidad,operador){
            res.map(viajesDB=>{
                if(viajesDB.length > 0)
                    this.sinResultados=false
                else
                    this.sinResultados = true
                let arregloViajes=[];
                if(unidad)
                    viajesDB= viajesDB.filter(viaje => {
                        console.log("unidad a evaluar",unidad);
                        console.log("unidad",viaje.claveUnidad);
                        return viaje.claveUnidad.indexOf(unidad) != -1
                    });
                if(operador)
                    viajesDB= viajesDB.filter(viaje => {
                        return viaje.claveDeOperador.indexOf(operador) != -1
                    });
                viajesDB.forEach(viaje => {
                    let inicio:any= new Date(viaje['inicioDeServicio'])
                    let fin:any=new Date(viaje['finDeServicio'])
                    var diffMs = (fin - inicio); // milliseconds between now & Christmas
                    var diffDays = Math.floor(diffMs / 86400000); // days
                    var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
                    var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
                    let $scope=this;
                    debugger
                    let aprobadoOno = viaje['viajeAceptado'];
                    console.log("Viaje",viaje);
                    let tooltipStr = '<div style="margin:1rem 0.5rem; width: 180px !important"><a href="https://operacion.trosten.com/#/planeacion/detalle-de-viaje/'+viaje['$key']+'" target="_blank">'+viaje['claveConfirmacion']+'</a><br>'+'<a href="https://trosten.azurewebsites.net/#/monitoreo/detalle-viaje/'+viaje['$key']+'" target="_blank">'+'Monitoreo'+'</a>'+'<br>'+
                        '<p style="margin-bottom: 0;"><b>Duración: </b>'+diffDays + " d, " + diffHrs + " hr, " + diffMins + " min"+'</p>'+
                        '<p style="margin-bottom: 0;"><b>Tipo Unidad: </b> '+viaje['tipoDeUnidad']+'</p>'+
                        '<p style="margin-bottom: 0;"><b>Inicio: </b> '+ inicio.getDate()+'/'+(inicio.getMonth()+1)+'/'+inicio.getFullYear() + ' a las '+inicio.getHours()+':'+ inicio.getMinutes()+':'+ inicio.getSeconds()+'</p>'+
                        '<p style="margin-bottom: 0;"><b>Fin: </b> '+ fin.getDate()+'/'+(fin.getMonth()+1)+'/'+fin.getFullYear() + ' a las  '+fin.getHours()+':'+ fin.getMinutes()+':'+ fin.getSeconds()+'</p>';
                    var yaEstaAprovado_txt = "";
                    if(aprobadoOno)
                    {
                        tooltipStr += '<p style="margin-bottom: 0;">' +
                                        '<b>Aprobado por Operador: </b> ' +
                                            '<i class="green-text fa fa-circle"></i>' +
                                        '</p>'+
                                    '</div>';
                        yaEstaAprovado_txt = 'CONFIRMADO';
                    }
                    else {
                        tooltipStr += '<p style="margin-bottom: 0;">' +
                            '<b>Aprobado por Operador: </b> ' +
                            '<i class="red-text fa fa-circle"></i>' +
                            '</p>'+
                            '</div>';
                        yaEstaAprovado_txt = 'SIN CONFIRMAR';
                    }
                    console.log(yaEstaAprovado_txt)
                    var estatusActual_txt = "";
                    if(viaje["estatusActual"] == undefined)
                    {
                        estatusActual_txt = "No Iniciado";
                    }
                    else {
                        estatusActual_txt = viaje["estatusActual"];
                    }

                    let arregloSimple=[
                        viaje['claveUnidad']+" - "+viaje['tipoDeUnidad'],
                        viaje['claveDeOperador']+" - "+yaEstaAprovado_txt + " - "+ estatusActual_txt,
                        tooltipStr,
                        inicio,
                        fin
                    ]
                    if(tipoDeUnidad == viaje['tipoDeUnidad'] && inicio.getTime() < fin.getTime())
                        arregloViajes.push(arregloSimple)
                    else if(tipoDeUnidad =='todas' && inicio.getTime() < fin.getTime())
                        arregloViajes.push(arregloSimple)

                });
                return arregloViajes
            }).subscribe(arreglo=>{
                debugger
                let $scope= this;
                arreglo.push(['.','El uso de esta linea es para poder mostrar el periodo de 40 horas','',new Date($scope.hoyInicio), new Date($scope.hoyFin)])
                google.charts.load('current', {'packages':['timeline']});
                google.charts.setOnLoadCallback(drawChart);
                function drawChart() {
                  var container = document.getElementById('timeline');
                  var chart = new google.visualization.Timeline(container);
                  var dataTable = new google.visualization.DataTable();
                  dataTable.addColumn({ type: 'string', id: 'claveUnidad' });
                  dataTable.addColumn({ type: 'string', id: 'servicio'});
                  dataTable.addColumn({ type: 'string', role: 'tooltip', 'p': {'html': true}});
                  dataTable.addColumn({ type: 'date', id: 'Start' });
                  dataTable.addColumn({ type: 'date', id: 'End' });
                  dataTable.addRows(arreglo);

                    var options = {
                        height:400,
                        allowHtml:true
                      };
                      google.visualization.events.addListener(chart,'onmouseover',function(e) {
                        var tooltip = document.querySelector('.google-visualization-tooltip:not([clone])');
                        //remove previous clone when there is any
                        if (chart.ttclone) {
                          chart.ttclone.parentNode.removeChild(chart.ttclone)

                        }
                        //create a clone of the built-in tooltip
                        chart.ttclone = tooltip.cloneNode(true);
                        //create a custom attribute to be able to distinguish
                        //built-in tooltip and clone
                        chart.ttclone.setAttribute('clone', true);
                        //inject clone into document
                        chart.ttclone.style.pointerEvents = 'auto';
                        tooltip.parentNode.insertBefore(chart.ttclone, chart.tooltip);
                      })

                      google.visualization.events.addListener(chart, 'select', function(e) {
                        //the built-in tooltip
                        var tooltip = document.querySelector('.google-visualization-tooltip:not([clone])');
                        //remove previous clone when there is any
                        if (chart.ttclone) {
                          chart.ttclone.parentNode.removeChild(chart.ttclone)

                        }
                        //create a clone of the built-in tooltip
                        chart.ttclone = tooltip.cloneNode(true);
                        //create a custom attribute to be able to distinguish
                        //built-in tooltip and clone
                        chart.ttclone.setAttribute('clone', true);
                        //inject clone into document
                        chart.ttclone.style.pointerEvents = 'auto';
                        tooltip.parentNode.insertBefore(chart.ttclone, chart.tooltip);
                      });

                    chart.draw(dataTable, options);
                }
            })
        }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/components/linea-tiempo-viajes/linea-tiempo-viajes.component.ts